var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAxnLogoSupernova(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#4F5CC4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Axion_Blue",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 1280,
    height: 1280
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M736.4,527.3l189.2-220.4L673.3,75.9c-19.9-18.2-47.3-18.2-67.2,0L327.9,330.5l-108.4,99.2c-14.2,13-22.5,33.4-22.5,55 V794c0,20.6,19.2,32.3,32.6,20l1.5-1.4l96.8-88.5v0l215-196.8l78.4-71.8c10.9-10,25.8-10,36.7,0L736.4,527.3L736.4,527.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "779.4,487.9 951.5,330.5 951.5,330.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "327.9,724 542.9,527.3 327.9,724  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.7,240.6l-98.3,89.9v0l-215,196.8L658,599c-10.9,10-25.8,10-36.7,0l-78.4-71.8L353.7,747.6l252.4,231 c19.9,18.2,47.3,18.2,67.2,0L951.5,724v0l108.4-99.2c14.2-13,22.5-33.3,22.5-55V260.6C1082.4,240,1063.2,228.3,1049.7,240.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.7,1253.4v-26.2H142l-25.3-65.4l-35.6,91.6H51.3l52.3-130.8h26.2l52.3,130.8H116.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,1188l-49.1-65.4h32.7l32.7,43.7l32.7-43.7h32.7l-49.1,65.4l49.1,65.4H411l-32.7-43.7l-32.7,43.7h-32.7L362,1188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.1,1122.5v130.8h-26.2v-130.8H653.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.2,1253.4v-130.8h130.8v130.8H836.2z M940.9,1227.2v-78.5h-78.5v78.5H940.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.9,1253.4v-130.8h26.2l78.5,92.8v-92.8h26.2v130.8h-26.2l-78.5-89.9v89.9H1097.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxnLogoSupernova);
export default __webpack_public_path__ + "static/media/axn_logo_supernova.5a3ccb0bbbf2f4f3399095be2208a891.svg";
export { ForwardRef as ReactComponent };